import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class MyServiceService {

  private base_url = environment.base_url;
  
  constructor(private http: HttpClient) {
    this.base_url = environment.base_url;
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    console.error('An error occurred:', error.error.message || error.message);
    return throwError('Something bad happened; please try again later.');
  }

  getSensors(): Observable<any> {
    return this.http.get(`${this.base_url}/realTime`).pipe(
      catchError(this.handleError)
    );
  }

  getParkingEvents(): Observable<any> {
    return this.http.get(`${this.base_url}/events`).pipe(
      catchError(this.handleError)
    );
  }

  getSpecificSensor(id): Observable<any> {
    const payload = { id };
    return this.http.post(`${this.base_url}/sensor`, payload).pipe(
      catchError(this.handleError)
    );
  }

  getSpecificSensorHistory(id): Observable<any> {
    const payload = { id };
    return this.http.post(`${this.base_url}/sensorHistory`, payload).pipe(
      catchError(this.handleError)
    );
  }
  getSpecificSensorHistoryWeek(id): Observable<any> {
    const payload = { id };
    return this.http.post(`${this.base_url}/sensorHistoryOld`, payload).pipe(
      catchError(this.handleError)
    );
  }

  getAllSensorsEvents(tw): Observable<any> {
    const payload = { "window": tw };
    return this.http.post(`${this.base_url}/allSensorsEvents`, payload).pipe(
      catchError(this.handleError)
    );
  }

  saveSensor(s_id, s_lat, s_lng, s_slot): Observable<any> {
    const payload = { "id": s_id, "lat": s_lat, "lng": s_lng, "slot": s_slot };
    return this.http.post(`${this.base_url}/saveSensor`, payload).pipe(
      catchError(this.handleError)
    );
  }

  editSensor(s_id, s_lat, s_lng, s_slot): Observable<any> {
    const payload = { "id": s_id };
    if (!(s_lat === undefined)) {
      payload['lat'] = s_lat;
    }
    if (!(s_lng === undefined)) {
      payload['lng'] = s_lng;
    }
    if (!(s_slot === undefined)) {
      payload['slot'] = s_slot;
    }

    return this.http.post(`${this.base_url}/editSensor`, payload).pipe(
      catchError(this.handleError)
    );
  }

  deleteSensor(s_id): Observable<any> {
    const payload = { "id": s_id };
    return this.http.post(`${this.base_url}/deleteSensor`, payload).pipe(
      catchError(this.handleError)
    );
  }
}